export type ParsedVideoTime = number | null | false;

export function parseVideoTimeInput(input: string): ParsedVideoTime {
  const trimmed = input.trim();
  if (!trimmed) return null;

  if (/^\d+$/.test(trimmed)) {
    return Number(trimmed);
  }

  const parts = trimmed.split(':');
  if (parts.length === 2) {
    const [minutesText, secondsText] = parts;
    if (!/^\d+$/.test(minutesText) || !/^\d{2}$/.test(secondsText)) return false;
    const seconds = Number(secondsText);
    if (seconds > 59) return false;
    return Number(minutesText) * 60 + seconds;
  }

  if (parts.length === 3) {
    const [hoursText, minutesText, secondsText] = parts;
    if (!/^\d+$/.test(hoursText) || !/^\d{2}$/.test(minutesText) || !/^\d{2}$/.test(secondsText)) {
      return false;
    }
    const minutes = Number(minutesText);
    const seconds = Number(secondsText);
    if (minutes > 59 || seconds > 59) return false;
    return Number(hoursText) * 3600 + minutes * 60 + seconds;
  }

  return false;
}

export function formatVideoTimecode(seconds: number | undefined | null): string {
  if (typeof seconds !== 'number' || !Number.isFinite(seconds) || seconds <= 0) return '';

  const total = Math.floor(seconds);
  const hours = Math.floor(total / 3600);
  const minutes = Math.floor((total % 3600) / 60);
  const remainingSeconds = total % 60;

  if (hours > 0) {
    return `${hours}:${String(minutes).padStart(2, '0')}:${String(remainingSeconds).padStart(2, '0')}`;
  }

  return `${minutes}:${String(remainingSeconds).padStart(2, '0')}`;
}
